// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2iatx","dragIcon":"Choice_dragIcon__1NXmn","left":"Choice_left__1JVyI","input":"Choice_input__3_y_B"};